export const ENDPOINTS = {
  // News & social
  news: '/news-feed',
  tweets: '/tweets',
  chatgpt: '/chatgpt',

  // User settings & billing
  userSettings: '/user/settings',
  userSubscription: '/user/subscription',
  userFleets: '/user/fleets',
  checkoutSession: '/user/checkout-session',
  userRegister: '/user/register',
  userAreas: '/user/areas',

  // Vessels
  vesselPosition: '/vessel/position',
  vessel: '/vessel',
  vesselVoyages: '/vessel/voyages',
  vesselViolations: '/violations',
  vesselReport: '/vessel/report',
  vesselReports: '/vessel/reports',
  vesselComments: '/vessel/comments',
  vesselCommentsPresign: '/vessel/comments/presign-media',

  // Rules & alerts
  rules: '/rules',
  ruleViolations: '/rules/violations',
  rulesColumns: '/rules/columns',

  // Tasking / satellites / sensor fusion
  tasking: '/tasking',
  satellites: '/satellites',
  sensorFusion: '/sensor-fusion',
  orders: '/oneapi/orders',
  imageProcessing: '/oneapi/tools/process-image',
  events: '/events',
  stream: '/tools/stream/',
  userImages: '/oneapi/images',

  // Map layers
  incidents: '/incidents',
  ports: '/ports',
  militaryLocations: '/military-locations',
};
